import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../services/supabase';
import type { DevotionalSeries } from './useDevotionalSeries';

export type UpsertDevotionalSeriesPayload = Partial<Omit<DevotionalSeries, 'id'>> & {
  id?: string;
  description?: string | null;
  thumbnail?: string | null;
};

export const useUpsertDevotionalSeries = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: UpsertDevotionalSeriesPayload) => {
      const { id, ...rest } = payload;
      if (id) {
        const { data, error } = await supabase
          .from('devotional_series')
          .update(rest)
          .eq('id', id)
          .select()
          .single();
        if (error) throw error;
        return data;
      }
      const { data, error } = await supabase.from('devotional_series').insert(rest).select().single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devotionalSeries'] });
    },
  });
};
